module.exports = __webpack_public_path__ + "img/production.b5e45eb5.svg";